<template>
  <div>
    <div id="entirety">
      <div id="headNav">
        <h6 class="head_text" @click="isCollapse = !isCollapse">傲举人事行政管理系统</h6>
        <div style="margin-right: 8%">
          <div style="display: flex; width: 100%">
            <el-badge :max="99" class="item">
              <el-button type="text" icon="el-icon-edit-outline" size="mini"
                style="font-size: 25px;color: white;top: -15px;position: relative;" @click="memoClick"><span
                  style="font-size: 15px;">便签</span></el-button>
            </el-badge>
            <el-dropdown>
              <el-badge :value="readNUm" :max="99" class="item">
                <el-button type="text" icon="el-icon-message-solid" size="mini"
                  style=" font-size: 25px;color: white;top: -15px;position: relative;"
                  @click="IsConterShow = true;"></el-button>
              </el-badge>
              <el-dropdown-menu slot="dropdown" style="max-height: 300px;" class="scrollHidden">
                <el-dropdown-item v-if="tableData.length == 0">现在还有收到通知</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>

            <el-dropdown trigger="click" @command="handleCommand" style="color: white;font-size: 19px;">
              <span class="el-dropdown-link">
                {{ username }}<i class="el-icon-arrow-down el-icon--right"></i>
              </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item command="a">退出登录</el-dropdown-item>
                <el-dropdown-item command="b">修改密码</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>

            <!-- <div style=" color: white;font-size: 18px; margin-right: 30px;font-weight: 700; ">
              {{ username }}
            </div>
            <el-button type="danger" icon="el-icon-switch-button" size="mini" style="height: 30px; margin-top: 15px"
              @click="Out"></el-button> -->
          </div>
        </div>
      </div>

      <div style="display: flex; width: 100%; height: calc(100% - 60px)">
        <div id="sideNav" class="scrollHidden">
          <el-menu :default-active="$route.name" class="el-menu-vertical-demo" @open="handleOpen" @close="handleClose"
            active-text-color="#0055ff" background-color="#121212" text-color="#fff" router :collapse="isCollapse"
            unique-opened @select="select">
            <template v-for="(item, index) in myRouter || []">
              <el-menu-item :index="item.authRemark.substring(1)" :route="item.authUrl" v-if="!item.children">
                <i :class="item.authIcon"></i>
                <span slot="title">{{ item.authName }}</span>
              </el-menu-item>
              <el-submenu :index="`${index}`" v-if="item.children && item.children.length > 0">
                <template slot="title">
                  <i :class="item.authIcon"></i>
                  <span>{{ item.authName }}</span>
                </template>
                <el-menu-item v-for="(items, idx) in item.children || []" :key="items.authId" :index="items.authRemark"
                  :route="items.authUrl">
                  <i :class="items.authIcon"></i>
                  <span slot="title">{{ items.authName }}</span>
                </el-menu-item>
              </el-submenu>
            </template>
            <!-- <el-menu-item index="userList" route="/Home/userList">
              <i class="el-icon-user-solid"></i>
              <span slot="title">用户管理</span>
            </el-menu-item>
            <el-submenu index="11">
              <template slot="title">
                <i class="el-icon-office-building"></i>
                <span>权限管理</span>
              </template>
              <el-menu-item index="role" route="/Home/role">
                <i class="el-icon-postcard"></i>
                <span slot="title">角色管理</span>
              </el-menu-item>
              <el-menu-item index="authority" route="/Home/authority">
                <i class="el-icon-postcard"></i>
                <span slot="title">菜单权限</span>
              </el-menu-item>
            </el-submenu> -->
            <!-- <el-submenu index="1">
              <template slot="title">
                <i class="el-icon-office-building"></i>
                <span>资产管理</span>
              </template>
              <el-menu-item index="corporateAssets" route="/Home/corporateAssets">
                <i class="el-icon-postcard"></i>
                <span slot="title">公司资产</span>
              </el-menu-item>
              <el-menu-item index="assetsType" route="/Home/assetsType">
                <i class="el-icon-tickets"></i>
                <span slot="title">资产分类</span>
              </el-menu-item>
              <el-menu-item index="AccessoryPartAll" route="/Home/AccessoryPartAll">
                <i class="el-icon-postcard"></i>
                <span slot="title">配件</span>
              </el-menu-item>
              <el-menu-item index="Consumebs" route="/Home/Consumebs">
                <i class="el-icon-postcard"></i>
                <span slot="title">易耗品</span>
              </el-menu-item>
              <el-menu-item index="AccessoryPartType" route="/Home/AccessoryPartType">
                <i class="el-icon-tickets"></i>
                <span slot="title">配件分类</span>
              </el-menu-item>
              <el-menu-item index="cyManufacturer" route="/Home/cyManufacturer">
                <i class="el-icon-s-shop"></i>
                <span slot="title">资产厂商</span>
              </el-menu-item>
              <el-menu-item index="phoneCard" route="/Home/phoneCard">
                <i class="el-icon-phone"></i>
                <span slot="title">手机卡</span>
              </el-menu-item>
            </el-submenu>
            <el-submenu index="2">
              <template slot="title">
                <i class="el-icon-s-flag"></i>
                <span>服务管理</span>
              </template>
              <el-menu-item index="BorrowingReturn" route="/Home/BorrowingReturn">
                <i class="el-icon-postcard"></i>
                <span slot="title">借还记录</span>
              </el-menu-item>
              <el-menu-item index="breakdown" route="/Home/breakdown">
                <i class="el-icon-postcard"></i>
                <span slot="title">故障记录</span>
              </el-menu-item>
              <el-menu-item index="DepreciationRule" route="/Home/DepreciationRule">
                <i class="el-icon-tickets"></i>
                <span slot="title">折旧规则</span>
              </el-menu-item>
            </el-submenu>
            <el-submenu index="3">
              <template slot="title">
                <i class="el-icon-notebook-2"></i>
                <span>花名册</span>
              </template>
              <el-menu-item index="Roster" route="/Home/Roster">
                <i class="el-icon-notebook-2"></i>
                <span slot="title">在职员工</span>
              </el-menu-item>
              <el-menu-item index="RosterLeave" route="/Home/RosterLeave">
                <i class="el-icon-notebook-2"></i>
                <span slot="title">离职员工</span>
              </el-menu-item>
              <el-menu-item index="RosterContract" route="/Home/RosterContract">
                <i class="el-icon-notebook-2"></i>
                <span slot="title">劳动合同</span>
              </el-menu-item>
              <el-menu-item index="RosterProve" route="/Home/RosterProve">
                <i class="el-icon-notebook-2"></i>
                <span slot="title">资质证书</span>
              </el-menu-item>
              <el-menu-item index="department" route="/Home/department">
                <i class="el-icon-notebook-2"></i>
                <span slot="title">部门管理</span>
              </el-menu-item>
              <el-menu-item index="Attribution" route="/Home/Attribution">
                <i class="el-icon-notebook-2"></i>
                <span slot="title">归属地管理</span>
              </el-menu-item>
            </el-submenu>
            <el-submenu index="5">
              <template slot="title">
                <i class="el-icon-s-help"></i>
                <span>社保公积金</span>
              </template>
              <el-menu-item index="social" route="/Home/social">
                <i class="el-icon-finished"></i>
                <span slot="title">社保公积金基数</span>
              </el-menu-item>
              <el-menu-item index="publicAccumulationFundBill" route="/Home/publicAccumulationFundBill">
                <i class="el-icon-tickets"></i>
                <span slot="title">公积金账单</span>
              </el-menu-item>
              <el-menu-item index="SocialBill" route="/Home/SocialBill">
                <i class="el-icon-document-copy"></i>
                <span slot="title">社保账单</span>
              </el-menu-item>
              <el-menu-item index="standingBook" route="/Home/standingBook">
                <i class="el-icon-document"></i>
                <span slot="title">社保公积金台账</span>
              </el-menu-item>
              <el-menu-item index="serviceCharge" route="/Home/serviceCharge">
                <i class="el-icon-document-remove"></i>
                <span slot="title">服务费税费</span>
              </el-menu-item>
              <el-menu-item index="InsuredSubject" route="/Home/InsuredSubject">
                <i class="el-icon-document-remove"></i>
                <span slot="title">参保主体</span>
              </el-menu-item>
            </el-submenu>
            <el-menu-item index="AddressBook" route="/Home/AddressBook">
              <i class="el-icon-notebook-1"></i>
              <span slot="title">通讯录</span>
            </el-menu-item>

            <el-menu-item index="SystemLog" route="/Home/SystemLog">
              <i class="el-icon-info"></i>
              <span slot="title">系统日志</span>
            </el-menu-item>
            <el-submenu index="4" v-if="userid == 1">
              <template slot="title">
                <i class="el-icon-s-grid"></i>
                <span>项目管理</span>
              </template>
              <el-menu-item index="SysCjCer" route="/Home/SysCjCer">
                <i class="el-icon-info"></i>
                <span slot="title">开发证书</span>
              </el-menu-item>
              <el-menu-item index="SysCjProject" route="/Home/SysCjProject">
                <i class="el-icon-info"></i>
                <span slot="title">项目信息</span>
              </el-menu-item>
              <el-menu-item index="SysCjProjectMilestone" route="/Home/SysCjProjectMilestone">
                <i class="el-icon-info"></i>
                <span slot="title">项目记录</span>
              </el-menu-item>
              <el-menu-item index="SysCjProjectSql" route="/Home/SysCjProjectSql">
                <i class="el-icon-info"></i>
                <span slot="title">数据库记录</span>
              </el-menu-item>
            </el-submenu> -->

          </el-menu>
          <!-- 
          <el-menu :default-active="$route.name" class="el-menu-vertical-demo" @open="handleOpen" @close="handleClose"
            active-text-color="#0055ff" background-color="#121212" text-color="#fff" router :collapse="isCollapse"
            unique-opened v-if="userPost == 3">
            <el-menu-item index="RosterProve" route="/Home/RosterProve">
              <i class="el-icon-notebook-1"></i>
              <span slot="title">资质证书</span>
            </el-menu-item>
          </el-menu> -->
        </div>

        <div id="main">
          <keep-alive>
            <router-view></router-view>
          </keep-alive>
        </div>
      </div>
    </div>
    <el-dialog :title="conterstr.noticeTitle" :visible.sync="Isconter" width="70%" top="8vh">
      <div style="margin: 15px;">
        {{ conterstr.noticeContent }}
      </div>
      <p style="margin: 15px;">通知时间:{{ conterstr.createtime }}</p>
    </el-dialog>
    <el-dialog title="消息列表" :visible.sync="IsConterShow" width="70%" top="8vh">
      <div style="width: 100%">
        <div style="display: flex;justify-content: space-between;margin: 15px;">
          <el-select v-model="formDatas.noticeTitle" placeholder="请选择标题" size="small" clearable @change="partserch">
            <el-option v-for="(item, index) in noticeTitleList || []" :label="item" :value="item" :key="index">
            </el-option>
          </el-select>
          <el-button type="danger" size="small" style="margin-right: 10px;" @click="readClick">一键已读</el-button>
        </div>
        <ve-table ref="vetable" v-if="tableData" :columns="columns" :table-data="tableData" :max-height="tableHight"
          :border-x="true" :border-y="true" :scrollWidth="10" :cell-style-option="cellStyleOption"
          :checkbox-option="checkboxOption" row-key-field-name="noticeId" :cellSelectionOption="cellSelectionOption"
          style="width: 100%" />
        <div v-show="tableData.length == 0" class="empty-data">暂无数据</div>
      </div>
      <div class="table-pagination">
        <ve-pagination :total="totalCount" :page-index="formDatas.currentPage" :page-size="formDatas.pageSize"
          :page-size-option="[10, 20, 40, 80, 160, 320, 640, 1000, 2000]" @on-page-number-change="pageNumberChange"
          @on-page-size-change="pageSizeChange" />
      </div>
    </el-dialog>
    <el-dialog title="修改密码" :visible.sync="updataPw" width="25%" center>
      <p>新密码</p>
      <el-input v-model="suPw" autocomplete="off"></el-input>

      <span slot="footer" class="dialog-footer">
        <el-button @click="updataPw = false; suPw = ''">取 消</el-button>
        <el-button type="primary" @click="updataPwclick">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog title="便签" :visible.sync="Ismemo" width="95%" style="margin-left:77%;margin-right: 3%;" center
      :modal="false" class="memoclass">
      <div slot="title" style="width:100%;height:50px;background-color:#009BDB;overflow: hidden;display: flex;">
        <div style="width:80px;text-align:center;background-color:white;height:30px;line-height:30px;font-size:18px;font-weight:400;
          border-radius: 8px;margin-top: 10px;margin-left: 15px;
         ">便签</div>
        <div style="margin-top: 15px;margin-left: 45%;">
          <i class=" el-icon-plus" style="font-size: 23px;color: #F56C6C;font-weight: 500;" @click="addMemo"></i>
        </div>
      </div>
      <div style="width: 100%;height: 60vh;overflow-y: auto;">
        <div v-if="MyMemoList.length > 0" style="width: 100%;">
          <el-card v-for="(item, index) in MyMemoList || []" :key="index" style="margin: 15px;">
            <div class="text-ellipsis text-ellipsis2" @click="handleDetail(item)"
              :style="{ 'textDecoration': item.sunStatus == 2 ? 'line-through' : 'none' }">
              {{ item.sunText }}
            </div>
            <div style="display: flex;margin-top:10px;border-top: 3px solid #009BDB;
              width: 100%;justify-content:space-between;align-items: center;">
              <div style="font-size: 13px; color: #009BDB;margin-top: 8px;">{{ item.createtime }}</div>
              <el-button type="text" style="color: #67C23A;margin-top: 8px;" size="mini" @click="handleEdit(item)"
                v-if="item.sunStatus != 2">编辑</el-button>
              <el-button type="text" style="color: #F56C6C;margin-top: 8px;" size="mini"
                @click="handleDelete(item)">删除</el-button>
              <el-button type="text" style="color: #E6A23C;margin-top: 8px;" size="mini" @click="handleDeal(item)"
                v-if="item.sunStatus != 2">完成</el-button>
            </div>
          </el-card>
        </div>

      </div>
      <div style="width: 100%;height: 90%;position: absolute;top: 55px;left: 0;background-color: white;"
        v-if="updataMemo">
        <div style="width: 100%;font-style: 19px;font-weight: 500;text-align: center;margin: 10px;">
          {{ Isedit ? '编辑便签' : IsDetail ? '便签详情' : '新增便签' }}
        </div>
        <div style="margin-top: 15px;">
          <el-input v-if="!IsDetail" type="textarea" :autosize="{ minRows: 10, maxRows: 18 }" placeholder="请输入内容"
            v-model="sunForm.sunText">
          </el-input>
          <div v-else style="width: 100%;max-height: 100px;overflow-y: auto;padding: 10px;">
            {{ sunForm.sunText }}
          </div>

        </div>

        <div style="display: flex;position: absolute;bottom: 10px;left: 0;width: 100%;justify-content: space-around;">
          <el-button @click="MemoClose">取 消</el-button>
          <el-button type="primary" v-if="!IsDetail" @click="updataMemoClick">确 定</el-button>
        </div>
      </div>
      <!-- <el-dialog title="编辑便签" :visible.sync="updataMemo" width="100%">

        <span slot="footer" class="dialog-footer">
          
        </span>
      </el-dialog> -->
    </el-dialog>
  </div>
</template>

<script>
import { mapState, mapMutations, mapAction } from 'vuex'
import {
  getSysNoticeList, getSysNoticeUnReadNum, deleteSysNoticeRead, updateSysNoticeRead, updateSysUserPw, updateSysNoticeReadAll, getSysUserNote,
  addSysUserNote, updateSysUserNote, updateSysUserNoteStatus, deleteSysUserNote, getSysUserDetails, getSysNoticeListTitle
} from "../api/api";
export default {
  name: "Home",
  data() {
    return {
      noticeTitleList: [],
      clickRouter: 'HomePage',
      IsDetail: false,
      Isedit: false,
      sunForm: {
        sunText: '',
      },
      updataMemo: false,
      MyMemoList: [],
      Ismemo: false,
      myRouter: [],
      suPw: '',
      updataPw: false,
      formDatas: {
        currentPage: 1,
        pageSize: 20,
      },
      columns: [
        {
          field: "",
          key: "a",
          title: "序号",
          width: 50,
          align: "center",
          fixed: 'left',
          renderBodyCell: ({ row, column, rowIndex }, h) => {
            return ++rowIndex;
          },
        },

        {
          field: "noticeTitle",
          key: "noticeTitle",
          title: "标题",
          align: "center",
          width: 200,

        },
        {
          field: "noticeContent",
          key: "noticeContent",
          title: "内容",
          align: "center",


        },
        {
          field: "createtime",
          key: "createtime",
          title: "通知时间",
          align: "center",
          width: 200,

        },
        {
          field: "",
          key: "d",
          title: "操作",
          width: 200,
          fixed: 'right',
          align: "center",
          renderBodyCell: ({ row, column, rowIndex }, h) => {
            return (
              <span>
                {
                  row.noticeStatus == 1 ? <el-button
                    size="mini"
                    type="text"
                    on-click={() => this.getRead(row)}
                  >
                    已读
                  </el-button> : ''
                }

                <el-button
                  size="mini"
                  type="text"
                  style="color: red"
                  on-click={() => this.deleteRead(row.noticeId)}
                >
                  删除
                </el-button>

              </span>
            );
          },
        }
      ],
      cellSelectionOption: {
        // disble cell selection
        enable: true,
      },
      totalCount: 100,
      pageIndex: 1,
      pageSize: 20,
      selectedRowKeysCollection: [],
      checkboxOption: {
        // 可控属性
        selectedRowKeys: [],
        // 行选择改变事件
        selectedRowChange: ({ row, isSelected, selectedRowKeys }) => {
          this.changeSelectedRowKeys(row, isSelected);
        },
        // 全选改变事件
        selectedAllChange: ({ isSelected, selectedRowKeys }) => {
          this.changeSelectAll(isSelected, selectedRowKeys);
        },
      },
      cellStyleOption: {
        headerCellClass: ({ column, rowIndex }) => {
          if (rowIndex === 0) {
            return "table-header-cell-class";
          }
        },
      },
      tableDataCopy: [],
      tableHight: 520,
      tableData: [],
      IsConterShow: false,

      userPost: '',
      Isconter: false,
      conterstr: '',
      post: localStorage.getItem("post"),
      userid: localStorage.getItem("userid"),
      username: "",
      readNUm: '',
      isCollapse: false,
    };
  },
  created() {
    console.log("首页",this.$router);
    getSysUserDetails().then(res => {
      if (res) {
        this.myRouter = res.data.ayRoleAuthList;
        console.log(this.myRouter);
        
        const clickRouter = localStorage.getItem('path')
        if (this.myRouter && clickRouter) {
          this.clickRouter = clickRouter
          this.$router.push(clickRouter);
          // window.close();


        } else {
          const path = res.data.ayRoleAuthList[0].children ? res.data.ayRoleAuthList[0].children[0].authUrl : res.data.ayRoleAuthList[0].authUrl
          this.$router.push(path);
          // window.close();
        }
      }
    })
    this.windheight = this.$store.state.windheight
    this.tableHight = this.windheight - 200 - this.windheight * 0.04;
    this.userid = localStorage.getItem("userid");
    this.userPost = localStorage.getItem("post");
    // if (this.userPost == 3) {
    //   this.$router.push('/Home/RosterProve');
    //   window.close();
    // }
    this.username = localStorage.getItem("suName");
    document.title = "傲举人事行政管理系统";
    getSysNoticeListTitle().then(res => {
      this.noticeTitleList = res.data
    })
    this.partserch();
    getSysNoticeUnReadNum().then(res => {
      if (res.data == 0) {
        this.readNUm = '';
        return
      }
      this.readNUm = res.data
    })



  },
  watch: {},
  activated() {
    this.username = localStorage.getItem("suName");
    document.title = "傲举人事行政管理系统";
    this.watchFlag = true;
    this.$nextTick(() => {
      this.windheight = this.$store.state.windheight;
      this.tableHight = this.windheight - 200 - this.windheight * 0.04;
    });
  },
  watch: {
    "$store.state.windheight"(val) {
      this.$nextTick(() => {
        if (this.watchFlag) {
          this.tableHight = val - 200 - val * 0.04;
        }
      });
    },
  },
  deactivated() {
    this.watchFlag = false;
    this.IsConterShow = false
  },
  methods: {
    ...mapMutations(['changeuser']),
    handleDelete(item) {
      this.$confirm("是否确定要删除, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          deleteSysUserNote({ sunId: item.sunId }).then(res => {
            if (res.data) {
              this.$message({
                type: "success",
                message: "删除成功!",
              });
              this.MemoClose()
              this.getMemoList()
            }
          })
        }).catch(() => {
          this.$message({
            type: "info",
            message: "已取消",
          });
        })
    },
    handleDeal(item) {
      this.$confirm("是否确实已完成, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          updateSysUserNoteStatus({ sunId: item.sunId }).then(res => {
            if (res.data) {
              this.$message({
                type: "success",
                message: "已完成!",
              });
              this.MemoClose()
              this.getMemoList()
            }
          })
        }).catch(() => {
          this.$message({
            type: "info",
            message: "已取消",
          });
        })
    },
    handleEdit(item) {
      const data = JSON.parse(JSON.stringify(item))
      this.sunForm = data;
      this.updataMemo = true;
      this.Isedit = true;
    },
    handleDetail(item) {
      const data = JSON.parse(JSON.stringify(item))
      this.sunForm = data;
      this.IsDetail = true;
      this.updataMemo = true;
    },
    getMemoList() {
      getSysUserNote().then(res => {
        this.MyMemoList = res.data
      })
    },
    MemoClose() {
      this.updataMemo = false;
      this.Isedit = false;
      this.IsDetail = false;
      this.sunForm = {
        sunText: '',
      }
    },
    updataMemoClick() {
      if (!this.Isedit) {
        this.$confirm("是否确定要新增, 是否继续?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            addSysUserNote(this.sunForm).then(res => {
              if (res.data) {
                this.$message({
                  type: "success",
                  message: "新增成功!",
                });
                this.MemoClose()
                this.getMemoList()
              }
            })
          }).catch(() => {
            this.$message({
              type: "info",
              message: "已取消",
            });
          })
      } else {
        this.$confirm("是否确定要编辑吗, 是否继续?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            updateSysUserNote(this.sunForm).then(res => {
              if (res.data) {
                this.$message({
                  type: "success",
                  message: "编辑成功!",
                });
                this.MemoClose()
                this.getMemoList()
              }
            })
          }).catch(() => {
            this.$message({
              type: "info",
              message: "已取消",
            });
          })
      }
    },
    addMemo() {
      this.updataMemo = true;
    },
    memoClick() {
      getSysUserNote().then(res => {
        this.MyMemoList = res.data
        this.Ismemo = true;
      })
    },
    readClick() {
      updateSysNoticeReadAll().then(res => {
        this.partserch()
      })
    },
    updataPwclick() {
      if (this.suPw == '') {
        this.$message({
          type: 'warning',
          message: '请输入密码!'
        })
      } else {
        updateSysUserPw({ suPw: this.suPw }).then(res => {
          this.$message({
            type: 'success',
            message: '修改成功!'
          })
          this.updataPw = false;
          this.suPw = '';

        })
      }
    },
    handleCommand(command) {
      if (command == "a") {
        this.Out()
      } else {
        this.updataPw = true;
      }
    },
    partserch() {
      this.formDatas.currentPage = 1;
      this.formDatas.checkStatus = 2;
      getSysNoticeList(this.formDatas).then((res) => {
        this.tableData = res.data;
        this.tableDataCopy = res.data;
        this.totalCount = res.total;
        this.resetSelectedRowKeys();

      });
      getSysNoticeUnReadNum().then(res => {
        if (res.data == 0) {
          this.readNUm = ''
          return
        }
        this.readNUm = res.data

      })
    },
    resetSelectedRowKeys() {
      console.log(this.checkboxOption.selectedRowKeys, this.selectedRowKeysCollection);
      this.checkboxOption.selectedRowKeys = [];

      const selectedRowKeysCollection = this.selectedRowKeysCollection;

      if (selectedRowKeysCollection.length) {
        this.tableData.forEach((item) => {
          if (selectedRowKeysCollection.indexOf(item.auId) > -1) {
            console.log(item);
            this.checkboxOption.selectedRowKeys.push(item.auId);
          }
        });
      }
    },
    pageSizeChange(pageSize) {
      this.formDatas.pageSize = pageSize;
      this.partserch();
    },
    pageNumberChange(pageIndex) {
      console.log(pageIndex);
      this.formDatas.currentPage = pageIndex;
      this.formDatas.checkStatus = 2;
      getSysNoticeList(this.formDatas).then((res) => {
        this.tableData = res.data;
        this.tableDataCopy = res.data;
        this.totalCount = res.total;
        this.resetSelectedRowKeys();
        // this.$message({
        //     type: "success",
        //     message: "搜索成功!",
        // });
      });

    },

    getRead(val) {
      // this.conterstr = val;
      // this.Isconter = true;
      if (val.noticeStatus == 1) {
        updateSysNoticeRead({ noticeIds: val.noticeId }).then(res => {
          this.partserch()
        })
      }
    },
    getlist() {
      getSysNoticeList().then(res => {
        console.log(res.data);
        this.tableData = res.data
      })

    },
    deleteRead(id) {
      this.$confirm("是否确定要删除通知吗, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          deleteSysNoticeRead({ noticeIds: id }).then(res => {
            this.partserch()
          })

        }).catch(() => {
          this.$message({
            type: "info",
            message: "已取消",
          });
        })
    },
    Out() {
      localStorage.clear();
      localStorage.clear();
      this.$router.push({
        path: "/doLogin",
      });
    },
    select(key, keyPath) {
      console.log(key, keyPath);
      localStorage.setItem('path', key);
    },
    handleOpen(key, keyPath) {
      console.log(key, keyPath);
    },
    handleClose(key, keyPath) {
      console.log(key, keyPath);
    },
  },
};
</script>

<style scoped="scoped">
.text-ellipsis {
  width: 100%;
  height: 40px;
  /* 设置容器的宽度 */
  /* white-space: nowrap;  */
  overflow: hidden;
  /* 隐藏溢出部分 */
}

.text-ellipsis2 {
  display: -webkit-box;
  /* 兼容性处理 */
  -webkit-line-clamp: 2;
  /* 限制显示行数 */
  -webkit-box-orient: vertical;
  /* 垂直方向显示 */
  overflow: hidden;
  /* 隐藏溢出部分 */
  text-overflow: ellipsis;
  /* 显示省略号 */
}

/deep/ .memoclass .el-card__body {
  padding: 10px !important;
}

/deep/ .memoclass .el-dialog__headerbtn {
  top: 15px !important;
}

/deep/ .memoclass .el-dialog__body {
  padding: 0 !important;
}

/deep/ .memoclass .el-dialog {
  border: 2px solid #009BDB !important;

}

/deep/ .memoclass .el-dialog__header {
  padding: 0 !important;
}

/deep/ .memoclass .el-icon-close:before {
  color: white;
  font-size: 25px;
}

.item {
  position: absolute;
  top: 5px;
  right: 20px;
  margin-top: 15px;
  margin-right: 40px;
}

#entirety {
  width: 100%;
  height: 100vh;
}

#headNav {
  width: 100%;
  height: 60px;
  line-height: 60px;
  background-color: #121212;
  display: flex;
  justify-content: space-between;
}

.scrollHidden {
  overflow-y: scroll;
}

.head_text {
  color: white;
  margin-left: 2em;
  font-size: 19px;
  margin-left: 2%;
}

#sideNav {
  /* width: 13%; */
  height: 100%;
  background-color: #121212;
  overflow-y: scroll;
  overflow-x: hidden;
}

#main {
  width: 100%;
  height: 100%;
  background-color: #fff;
  overflow: hidden;
}

.el-menu-vertical-demo:not(.el-menu--collapse) {
  width: 230px;
  min-height: 400px;
}

div /deep/ .el-submenu__icon-arrow {
  right: 40px;
}

/* 隐藏滚动条 */
.scrollHidden::-webkit-scrollbar {
  display: none;
}
</style>
